import { hbs } from 'ember-cli-htmlbars';
export default hbs("<div class=\"nw-settings__body\">\n  <Settings::SettingsNav @user={{@user}} />\n  <div class=\"nw-settings__main\">\n    {{yield}}\n  </div>\n</div>")